import Declined from '../Assets/Images/stop.png';
import { Empty } from 'antd';
import React from 'react';
import { getModuleCodesForPath, getRawPermissions } from './HasPermission';

export default function Role(ComposedComponent: any) {
  const grantRole = (props: any) => {
    const { location } = props;

    const currentPath =
      (process.env.REACT_APP_PUBLIC_URL
        ? location.pathname.replace(process.env.REACT_APP_PUBLIC_URL, '')
        : location.pathname) || '/';

    const rawPermissions = getRawPermissions();
    let granted = false;

    if (rawPermissions.length) {
      const moduleCodes = getModuleCodesForPath(currentPath);

      for (const moduleCode of moduleCodes) {
        const prefix = `${moduleCode}.`;
        if (
          rawPermissions.some(
            perm => perm.startsWith(prefix) || perm === moduleCode,
          )
        ) {
          granted = true;
          break;
        }
      }
    }

    if (granted) {
      return <ComposedComponent {...props} />;
    } else {
      return (
        <Empty
          image={Declined}
          className="customEmptyImage"
          description={
            <span className="containerContentDashboardTrainer">
              You don't have permission to access this page!
            </span>
          }
        />
      );
    }
  };

  return grantRole;
}
